import "./footer.css";
import { Link } from "react-router-dom";
import logo_ar from "../../images/logo_ar.png";
import logo_en from "../../images/logo.png";
import { FaLinkedin, FaFacebookF } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer>
      <div className="container footer__container">
        <article>
          <Link to="/" className="logo">
            <img
              src={document.body.dir === "ltr" ? logo_en : logo_ar}
              alt="footer logo"
            />
          </Link>
          <p>{t("footer_P")}</p>
          <div className="footer__social">
            <a
              href="https://www.linkedin.com/company/bilady-group/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=100068987141013"
              target="_blank"
              rel="noreferrer noopener"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/biladygroup/"
              target="_blank"
              rel="noreferrer"
            >
              <AiFillInstagram />
            </a>
          </div>
        </article>
        <article>
          <h4>{t("constantLinks")}</h4>
          <Link to="/">{t("footerHomeLink")}</Link>
          <Link to="/about">{t("footerAboutLink")}</Link>
          <Link to="/news">{t("footerNewsLink")}</Link>
          <Link to="/products">{t("footerProductsLink")}</Link>
          <Link to="/contact">{t("footerContactLink")}</Link>
        </article>
        <article>
          <h4>{t("getInTouch")}</h4>
          <Link to="/contact">{t("footerContactLink")}</Link>
          <Link to="/s">{t("supportLink")}</Link>
        </article>
      </div>
      <div className="footer__copyrights">
        <small>2023 &copy; R</small>
      </div>
    </footer>
  );
};

export default Footer;
